var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-item-wrapper',_vm._b({},'form-item-wrapper',_vm.bind,false),[_vm._v(" "+_vm._s(_vm.formatName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }